import React from "react"
import DepartmentHeader from "../components/DepartmentHeader"
import {RoundelGrid} from "../components/RoundelGrid"
import {computingGaming} from "./dummyData"
import {useTheme} from "@irati/ui/src/global/useTheme"

const DepartmentScreen = () => {
  const theme = useTheme()

  return (
    <>
      <DepartmentHeader />

      <RoundelGrid roundels={computingGaming} roundelBackgroundColor={theme.colors.greys.grey03} />
    </>
  )
}

export default DepartmentScreen
